import {CLIENT_TYPE_ENUM} from "@/utils";

export const INVOICE_TRANSMISSION_STATUS = {
    "fr:200": {
        label: "Validée",
        color: "#2e7d32",
        backgroundColor: "#e8f5e9"
    },
    "fr:201": {
        label: "Émise par la PA",
        color: "#1565c0",
        backgroundColor: "#e3f2fd"
    },
    "fr:202": {
        label: "Reçue par la PA",
        color: "#2e7d32",
        backgroundColor: "#e8f5e9"
    },
    "fr:203": {
        label: "Mise à disposition",
        color: "#6a1b9a",
        backgroundColor: "#f3e5f5"
    },
    "fr:204": {
        label: "Accusée de réception",
        color: "#1565c0",
        backgroundColor: "#e3f2fd"
    },
    "fr:205": {
        label: "Acceptée",
        color: "#1b5e20",
        backgroundColor: "#c8e6c9"
    },
    "fr:206": {
        label: "Partiellement acceptée",
        color: "#558b2f",
        backgroundColor: "#dcedc8"
    },
    "fr:207": {
        label: "Mise en litige",
        color: "#ef6c00",
        backgroundColor: "#fff3e0"
    },
    "fr:208": {
        label: "Suspendue",
        color: "#f57c00",
        backgroundColor: "#ffe0b2"
    },
    "fr:209": {
        label: "Terminée",
        color: "#2e7d32",
        backgroundColor: "#e8f5e9"
    },
    "fr:210": {
        label: "Refusée",
        color: "#c62828",
        backgroundColor: "#ffebee"
    },
    "fr:211": {
        label: "Paiement envoyé",
        color: "#1565c0",
        backgroundColor: "#e3f2fd"
    },
    "fr:212": {
        label: "Paiement reçu",
        color: "#1b5e20",
        backgroundColor: "#c8e6c9"
    },
    "fr:213": {
        label: "Rejetée",
        color: "#b71c1c",
        backgroundColor: "#ffcdd2"
    },
    "fr:501": {
        label: "Inadmissible",
        color: "#b71c1c",
        backgroundColor: "#ffcdd2"
    },
    "api:uploaded": {
        label: "Téléversée",
        color: "#1565c0",
        backgroundColor: "#e3f2fd"
    },
    "api:validated": {
        label: "Validée",
        color: "#2e7d32",
        backgroundColor: "#e8f5e9"
    },
    "validation:pending": {
        label: "Validation en cours",
        color: "#ef6c00",
        backgroundColor: "#fff8e1"
    },
    "validation:ok": {
        label: "Validée",
        color: "#2e7d32",
        backgroundColor: "#e8f5e9"
    },
    "validation:error": {
        label: "Erreur de validation",
        color: "#c62828",
        backgroundColor: "#ffebee"
    },
    "ppf:received": {
        label: "Reçue par le PPF",
        color: "#00695c",
        backgroundColor: "#e8f5e9"
    },
    "ppf:accepted": {
        label: "Acceptée par le PPF",
        color: "#1b5e20",
        backgroundColor: "#c8e6c9"
    },
    "ppf:rejected": {
        label: "Refusée par le PPF",
        color: "#b71c1c",
        backgroundColor: "#ffcdd2"
    },
    "recipient:received": {
        label: "Reçue par le destinataire",
        color: "#1565c0",
        backgroundColor: "#e3f2fd"
    },
    "recipient:accepted": {
        label: "Acceptée par le destinataire",
        color: "#1b5e20",
        backgroundColor: "#c8e6c9"
    },
    "recipient:rejected": {
        label: "Refusée par le destinataire",
        color: "#b71c1c",
        backgroundColor: "#ffcdd2"
    }
};

export const INVOICE_TRANSMISSION_ENU = {
    "fr:200": {
        label: "Validée",
    },
    "fr:201": {
        label: "Émise par la PA",
    },
    "fr:202": {
        label: "Reçue par la PA",
    },
    "fr:203": {
        label: "Mise à disposition",
    },
    "fr:204": {
        label: "Accusée de réception",
    },
    "fr:205": {
        label: "Acceptée",
    },
    "fr:206": {
        label: "Partiellement acceptée",
    },
    "fr:207": {
        label: "Mise en litige",
    },
    "fr:208": {
        label: "Suspendue",
    },
    "fr:209": {
        label: "Terminée",
    },
    "fr:210": {
        label: "Refusée",
    },
    "fr:211": {
        label: "Paiement envoyé",
    },
    "fr:212": {
        label: "Paiement reçu",
    },
    "fr:213": {
        label: "Rejetée",
    },
    "fr:501": {
        label: "Inadmissible",
    },
    "api:uploaded": {
        label: "Téléversée",
    },
    "api:validated": {
        label: "Validée",
    },
    "validation:pending": {
        label: "Validation en cours",
    },
    "validation:ok": {
        label: "Validée",
    },
    "validation:error": {
        label: "Erreur de validation",
    },
    "ppf:received": {
        label: "Reçue par le PPF",
    },
    "ppf:accepted": {
        label: "Acceptée par le PPF",
    },
    "ppf:rejected": {
        label: "Refusée par le PPF",
    },
    "recipient:received": {
        label: "Reçue par le destinataire",
    },
    "recipient:accepted": {
        label: "Acceptée par le destinataire",
    },
    "recipient:rejected": {
        label: "Refusée par le destinataire",
    }
};
export const INVOICE_TRANSMISSION_STATUS_ENUM = {
    VALIDATED: { label: 'Validée', value: "fr:200" },
    ISSUED_BY_PA: { label: 'Émise par la PA', value: "fr:201" },
    RECEIVED_BY_PA: { label: 'Reçue par la PA', value: "fr:202" },
    AVAILABLE: { label: 'Mise à disposition', value: "fr:203" },
    ACKNOWLEDGED: { label: 'Accusée de réception', value: "fr:204" },
    ACCEPTED: { label: 'Acceptée', value: "fr:205" },
    PARTIALLY_ACCEPTED: { label: 'Partiellement acceptée', value: "fr:206" },
    DISPUTED: { label: 'Mise en litige', value: "fr:207" },
    SUSPENDED: { label: 'Suspendue', value: "fr:208" },
    COMPLETED: { label: 'Terminée', value: "fr:209" },
    REFUSED: { label: 'Refusée', value: "fr:210" },
    PAYMENT_SENT: { label: 'Paiement envoyé', value: "fr:211" },
    PAYMENT_RECEIVED: { label: 'Paiement reçu', value: "fr:212" },
    REJECTED: { label: 'Rejetée', value: "fr:213" },
    INADMISSIBLE: { label: 'Inadmissible', value: "fr:501" },

    UPLOADED: { label: 'Téléversée', value: "api:uploaded" },
    API_VALIDATED: { label: 'Validée', value: "api:validated" },

    VALIDATION_PENDING: { label: 'Validation en cours', value: "validation:pending" },
    VALIDATION_OK: { label: 'Validée', value: "validation:ok" },
    VALIDATION_ERROR: { label: 'Erreur de validation', value: "validation:error" },

    PPF_RECEIVED: { label: 'Reçue par le PPF', value: "ppf:received" },
    PPF_ACCEPTED: { label: 'Acceptée par le PPF', value: "ppf:accepted" },
    PPF_REJECTED: { label: 'Refusée par le PPF', value: "ppf:rejected" },

    RECIPIENT_RECEIVED: { label: 'Reçue par le destinataire', value: "recipient:received" },
    RECIPIENT_ACCEPTED: { label: 'Acceptée par le destinataire', value: "recipient:accepted" },
    RECIPIENT_REJECTED: { label: 'Refusée par le destinataire', value: "recipient:rejected" },
};

export const INVOICE_TRANSMISSION_NO_ACTION_REQUIRED_STATUSES = [
    "fr:200",
    "fr:201",
    "fr:202",
    "fr:203",
    "fr:204",
    "fr:205",
    "fr:209",
    "fr:211",
    "fr:212",
    "api:uploaded",
    "api:validated",
    "validation:pending",
    "validation:ok",
    "ppf:received",
    "ppf:accepted",
    "recipient:received",
    "recipient:accepted"
];

const DEFAULT_STATUS = {
    label: "Statut inconnu",
    color: "#616161",
    backgroundColor: "#eeeeee"
};

export function getTransmissionStatusInfo(status) {
    return INVOICE_TRANSMISSION_STATUS[status] || DEFAULT_STATUS;
}

export function getTransmissionStatus(status) {
    return getTransmissionStatusInfo(status).label;
}

export function getTransmissionStatusDotStyle(status) {
    const info = getTransmissionStatusInfo(status);

    return {
        backgroundColor: info.color
    };
}

export function getTransmissionStatusStyle(status) {
    const info = getTransmissionStatusInfo(status);

    return {
        color: info.color,
        backgroundColor: info.backgroundColor
    };
}

export const ElectronicInvoicingType = {
    E_INVOICING: "e-invoicing",
    E_REPORTING_B2C: "e-reporting-b2c",
    E_REPORTING_INTERNATIONAL: "e-reporting-international"
};

export const CLIENT_TYPE_TO_ELECTRONIC_INVOICING_TYPE = {
    [CLIENT_TYPE_ENUM.FRENCH_COMPANY.value]: ElectronicInvoicingType.E_INVOICING,
    [CLIENT_TYPE_ENUM.INTERNATIONAL_COMPANY.value]: ElectronicInvoicingType.E_REPORTING_INTERNATIONAL,
    [CLIENT_TYPE_ENUM.INDIVIDUAL.value]: ElectronicInvoicingType.E_REPORTING_B2C
}